import React from 'react';

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from 'components/UI/Pagination/Pagination';
import { getUri } from 'services/generic';
import { PagerType } from 'types/ProductListing/ProductListing';

type PropsType = { pager: PagerType };

export default function BotPager({ pager }: PropsType): JSX.Element {
  const { pages, nextPageUrl, previousPageUrl } = pager;

  return (
    <Pagination>
      <PaginationContent>
        {previousPageUrl && <PaginationPrevious to={getUri(previousPageUrl)} />}
        {Object.keys(pages).map(pageIndex => (
          <PaginationItem key={pageIndex}>
            <PaginationLink to={getUri(pages[pageIndex])}>
              {pageIndex}
            </PaginationLink>
          </PaginationItem>
        ))}
        {nextPageUrl && <PaginationNext to={getUri(nextPageUrl)} />}
      </PaginationContent>
    </Pagination>
  );
}
